import React, { useEffect, useState } from 'react';
import { Button } from './Button';
interface NavigationProps {
  onApplyClick: () => void;
}
export function Navigation({
  onApplyClick
}: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    element?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className="sticky top-0 z-50 border-b border-transparent transition-colors duration-300" style={{
    backgroundColor: `rgba(5, 8, 20, ${isScrolled ? 0.8 : 0})`,
    backdropFilter: `blur(${isScrolled ? 12 : 0}px)`,
    borderColor: isScrolled ? 'rgba(30, 41, 59, 0.5)' : 'transparent'
  }} data-id="element-376">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-377">
        <div className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-mint-500 to-wave-500 cursor-pointer" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} data-id="element-378">
          Pulsewave
        </div>

        <div className="hidden md:flex items-center gap-8" data-id="element-379">
          <button onClick={() => scrollToSection('faq')} className="text-slate-300 hover:text-mint-500 transition-colors text-sm font-medium" data-id="element-380">
            FAQ
          </button>
          <Button variant="primary" className="!py-2 !px-5 text-sm bg-gradient-to-r from-mint-500 to-wave-500 hover:shadow-mint-500/25 border-none text-navy-950 font-bold" onClick={onApplyClick} data-id="element-381">
            Apply
          </Button>
        </div>
      </div>
    </nav>;
}